module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6I2ViNTUwNTt9LmJ7ZmlsbDojZmZmO308L3N0eWxlPjwvZGVmcz48dGl0bGU+YXJyb3ctZG93bi1vcmFuZ2U8L3RpdGxlPjxjaXJjbGUgY2xhc3M9ImEiIGN4PSIyNCIgY3k9IjI0IiByPSIyNCIvPjxwYXRoIGNsYXNzPSJiIiBkPSJNMjQsMjhMMTQuNCwxOCwxMiwyMC40OGw5LjYsMTBMMjQsMzNsMi40LTIuNTEsOS42LTEwTDMzLjYsMThaIi8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/arrow-down-orange.svg
// module id = FkXK
// module chunks = 0